import { Column } from '@shared';

export class Restaurant {
  id: string = '';
  @Column({
    title: 'Restaurant Name',
    field: 'name',
    order: 0.1,
    width: 20,
    sortable: true,
    filterable: true,
    filterType: 'text',
    visibleInQuickView: true,
  })
  name: string = '';

  @Column({
    title: 'Member Name',
    field: 'memberName',
    order: 0.1,
    width: 20,
    sortable: true,
    filterType: 'text',
    filterable: true,
    visibleInQuickView: true,
  })
  memberName: string = '';

  @Column({
    title: 'Status',
    field: 'restaurantStatus',
    order: 0.1,
    width: 20,
    sortable: true,
    filterable: true,
    filterType: 'text',
    visibleInQuickView: true,
  })
  restaurantStatus: string = '';

  @Column({
    title: 'Time Zone',
    field: 'timeZone',
    order: 0.1,
    width: 20,
    sortable: true,
    filterable: true,
    filterType: 'text',
    visibleInQuickView: true,
  })
  timeZone: string = '';

  @Column({
    title: 'Price Tier',
    field: 'priceTierName',
    order: 0.1,
    width: 20,
    sortable: true,
    filterable: true,
    visibleInQuickView: true,
    filterType: 'text',
  })
  priceTierName: string = '';

  @Column({
    title: 'Par Token',
    field: 'parToken',
    order: 0.1,
    width: 25,
    sortable: true,
    filterable: true,
    visibleInQuickView: true,
    editable: true,
    filterType: 'text',
  })
  parToken: string = '';

  // @Column({
  //   title: 'Is King',
  //   field: 'isKing',
  //   order: 0.1,
  //   width: 20,
  //   sortable: true,
  //   visibleInQuickView: true,
  //   type: 'boolean',
  //   filterOptions: [
  //     { name: 'Yes', value: true },
  //     { name: 'No', value: false },
  //   ],
  // })
  isKing: boolean = false;

  // @Column({
  //   title: 'Is Virtual',
  //   field: 'isVirtual',
  //   order: 0.1,
  //   width: 20,
  //   sortable: true,
  //   visibleInQuickView: true,
  //   type: 'boolean',
  //   filterOptions: [
  //     { name: 'Yes', value: true },
  //     { name: 'No', value: false },
  //   ],
  // })
  isVirtual: boolean = false;
}
